import {
  editSearchAlert
} from "./chunk-P726OJQE.js";
import {
  getConfigWithMetadata,
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/editSearchAlert/editSearchAlert.ts
async function editSearchAlert2(searchAlertId, editSearchAlertRequest, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "editSearchAlert");
    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
      );
    }
    await editSearchAlert(searchAlertId, editSearchAlertRequest, _apiConfig);
    return { status: "success", data: void 0 };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  editSearchAlert2 as editSearchAlert
};
